import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";

import rocket from '../../theme/assets/other/lp_about_s3_rocket.png';

const AboutS3 = () => {
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.textWrap}`}>
                    <div className={`${Styles.contentWrapTitle}`}>{t('Наша')} <span>{t('миссия')}</span></div>
                    <div className={`${Styles.noteWrap}`}>
                        <div className={`${Styles.noteItem}`}>{t('Наша главная цель — создавать среду, где технологии, знания и подготовленное сообщество работают вместе, чтобы проекты развивались устойчиво, а участники получали реальные возможности для роста и прибыли. Мы стремимся соединять сильные идеи с сильными людьми, обеспечивая прозрачность, безопасность и максимальную эффективность на каждом этапе запуска.')}</div>
                        <div className={`${Styles.noteItem}`}>{t('Иными словами, мы строим экосистему, где ценность создаётся системно, для всех сторон и на долгосрочную перспективу.')}</div>
                        <div className={`${Styles.noteItem}`}>{t('Мы считаем, что запуски должны создавать экосистемы, а не только краткосрочную ликвидность.')}</div>
                    </div>
                </div>
                <div className={`${Styles.imgWrap}`}>
                    <img src={rocket} alt={t('миссия')}/>
                </div>
            </div>
        </section>
    );
};

export default AboutS3;




